import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import chatIcon from '../assets/icon-chat.png';
import personIcon from '../assets/icon-person.png';
import dashboardIcon from '../assets/icon-dashboard.png';
import chartsIcon from '../assets/icon-charts.png';
import customIcon from '../assets/icon-custom.png';
import supportIcon from '../assets/icon-support.png';
// Ejemplo en Sidebar.jsx
import profileSidebarIcon from '../assets/profile-sidebar.png'; 
import { getAllAssistants } from '../services/openaiService';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const [assistants, setAssistants] = useState([]);


  const handleLogout = async () => {
    try { 
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  useEffect(() => {
    if (currentUser) {
      getAllAssistants(currentUser.uid)
        .then(data => setAssistants(data))
        .catch(err => console.error("Error fetching assistants:", err));
    }
  }, [currentUser]);


    // Si se cargaron asistentes, usamos el id del primero; de lo contrario, fallback a "/messages"
    const messagesUrl = assistants.length > 0 ? `/messages/${assistants[0].id}` : "/messages";

  return (
    <div className="sidebar">
      {/* Sección superior de iconos */} 
      <div className="sidebar-top">
      <Link to={messagesUrl} className="sidebar-icon" data-tooltip="Mensajes">
          <img src={chatIcon} alt="Chat" />
        </Link>
        <Link to="/crm" className="sidebar-icon" data-tooltip="CRM">
          <img src={dashboardIcon} alt="Dashboard" />
        </Link>
        <Link to="/analytics" className="sidebar-icon" data-tooltip="Analíticas">
          <img src={chartsIcon} alt="Charts" />
        </Link>
      </div>

      {/* Sección inferior de iconos */}
      <div className="sidebar-bottom">
        {/* <Link to="" className="sidebar-icon" data-tooltip="Integraciones">
          <img src={customIcon} alt="Custom" />
        </Link> */}
              <Link to="/" className="sidebar-icon" data-tooltip="Agentes">
          <img src={personIcon} alt="Agentes" />
        </Link>
       {/*  <Link to="/support" className="sidebar-icon" data-tooltip="Soporte">
          <img src={supportIcon} alt="Support" />
        </Link> */}
        <Link to="/profile" className="sidebar-icon" data-tooltip="Perfil">
    {/* Cambiamos paymentsIcon por profileSidebarIcon */}
    <img src={profileSidebarIcon} alt="Profile" /> 
  </Link>
        <button 
          onClick={handleLogout} 
          className="sidebar-icon logout-button" 
          data-tooltip="Cerrar sesión"
        >
          <FontAwesomeIcon icon={faRightFromBracket} />
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
